import React from 'react'
import { css } from '@emotion/core'
import { usePinMarkImg } from '../../../utils/usePinMarkImg'

type $FIXME = any

export const Pin = ({ pin }: $FIXME) => {
  const { src, onError } = usePinMarkImg(pin.pin_id)
  return <img alt="" css={pinStyle} src={src} onError={onError} />
}

// emotion
const pinStyle = css({
  width: '20px',
  height: 'auto',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  '-webkit-transform': 'translate(-50%, -50%)',
  '-ms-transform': 'translate(-50%, -50%)',
  cursor: 'pointer'
})
